import { fetchJsonWithAuth, apiGetWithAuth } from './authApi';
import { AUTH_URL, SUBMISSIONS_URL } from './apiConfig';

const TEST_FLOW_MODULE = 'test-flows';
const LMS_FLOW_MODULE = 'lms-flows';

const TEST_FLOW_FIELDS = [
  { value: 'module',      label: 'Module',      isVisible: true, type: 'text'   },
  { value: 'flow',        label: 'Flow',        isVisible: true, type: 'text'   },
  { value: 'step_order',  label: 'Step Order',  isVisible: true, type: 'number' },
  { value: 'keyword',     label: 'Action',      isVisible: true, type: 'text'   },
  { value: 'description', label: 'Description', isVisible: true, type: 'text'   },
  { value: 'target',      label: 'Key',         isVisible: true, type: 'text'   },
  { value: 'tags',        label: 'Tags',        isVisible: true, type: 'text'   },
  { value: 'value',       label: 'Value',       isVisible: true, type: 'text'   },
  { value: 'expected',    label: 'Expected',    isVisible: true, type: 'text'   },
];

const LMS_FLOW_FIELDS = [
  { value: 'module',      label: 'Module',      isVisible: true, type: 'text'   },
  { value: 'flow',        label: 'Flow',        isVisible: true, type: 'text'   },
  { value: 'step_order',  label: 'Step Order',  isVisible: true, type: 'number' },
  { value: 'keyword',     label: 'Action',      isVisible: true, type: 'text'   },
  { value: 'description', label: 'Description', isVisible: true, type: 'text'   },
  { value: 'target',      label: 'Key',         isVisible: true, type: 'text'   },
  { value: 'tags',        label: 'Tags',        isVisible: true, type: 'text'   },
  { value: 'value',       label: 'Value',       isVisible: true, type: 'text'   },
  { value: 'expected',    label: 'Expected',    isVisible: true, type: 'text'   },
];

export async function getDropdownFields(module) {
  if (module === TEST_FLOW_MODULE) return TEST_FLOW_FIELDS;
  if (module === LMS_FLOW_MODULE) return LMS_FLOW_FIELDS;
  return apiGetWithAuth(SUBMISSIONS_URL, `/filter-dropdown-fields?module=${encodeURIComponent(module)}`);
}

export async function getFieldConfig(module) {
  if (module === TEST_FLOW_MODULE) return TEST_FLOW_FIELDS;
  if (module === LMS_FLOW_MODULE) return LMS_FLOW_FIELDS;
  return apiGetWithAuth(AUTH_URL, `/admin/field-config?module=${encodeURIComponent(module)}`);
}

export async function getDropdownValues(module, field, search = '', limit = 50, offset = 0, meta = {}) {
  const params = new URLSearchParams({
    module, field, value: search,
    limit: String(limit), offset: String(offset),
  });
  if (meta.dataSource) params.set('dataSource', meta.dataSource);
  if (meta.masterName) params.set('masterName', meta.masterName);
  if (meta.groupName) params.set('groupName', meta.groupName);
  // The Auth gateway owns the admin form configuration and understands
  // dataSource/masterName. Keeping this generic lets every configured master,
  // module and lookup field work without module-specific UI code.
  return apiGetWithAuth(AUTH_URL, `/filter-dropdown-values?${params}`);
}

export async function getModuleDataList(module, limit = 10, offset = 0, options = {}) {
  const { scope = '', sort = '', sortDir = '' } = options;

  if (module === TEST_FLOW_MODULE) {
    const { getTestFlows } = await import('./testingApi');
    const data = await getTestFlows({ limit, offset });
    const rows = Array.isArray(data?.items) ? data.items : [];
    const total = Number(data?.total) || 0;
    return { items: rows, total, limit, offset, tabs: [{ key: 'all', title: 'Test Cases', count: total }] };
  }

  if (module === LMS_FLOW_MODULE) {
    const { getLmsFlows } = await import('./testingApi');
    const data = await getLmsFlows({ limit, offset });
    const rows = Array.isArray(data?.items) ? data.items : [];
    const total = Number(data?.total) || 0;
    return { items: rows, total, limit, offset, tabs: [{ key: 'all', title: 'LMS Cases', count: total }] };
  }

  const params = new URLSearchParams({ module, limit: String(limit), offset: String(offset) });
  if (scope) params.set('scope', scope);
  if (sort) params.set('sort', sort);
  if (sortDir) params.set('sortDir', sortDir);

  return fetchJsonWithAuth(AUTH_URL, `/module-data-list?${params.toString()}`);
}

export async function searchModuleData(moduleName, searchParams = {}, pagination = {}, options = {}) {
  console.log("THIS FUNCTION IS COMING IN")
  const { limit = 10, offset = 0 } = pagination;
  const { sort = '', sortDir = '', scope = '' } = options;

  const query = new URLSearchParams();
  query.append('module', moduleName);
  query.append('limit', String(limit));
  query.append('offset', String(offset));

  if (scope) query.set('scope', scope);
  if (sort) query.set('sort', sort);
  if (sortDir) query.set('sortDir', sortDir);

  Object.entries(searchParams).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;

    let normalizedValue = value;
    if (typeof value === 'object') {
      normalizedValue = value.value ?? value.label ?? value.name ?? String(value);
    } else {
      normalizedValue = String(value);
    }

    query.append(key, normalizedValue);
  });

  const response = await fetchJsonWithAuth(AUTH_URL, `/module-data-list?${query.toString()}`);
  console.log("SEARCH", response)
  // response = { status, data: { actionRules, actions, columnActions, data: [...records] } }
  const payload = response?.data ?? response;
  const rows = Array.isArray(payload)
    ? payload
    : payload?.rows ?? payload?.records ?? payload?.items ?? payload?.list ?? payload?.data ?? [];

  const total = response?.total
    ?? response?.count
    ?? response?.totalCount
    ?? payload?.total
    ?? payload?.count
    ?? payload?.totalCount
    ?? rows.length;

  return {
    rows: Array.isArray(rows) ? rows : [],
    total: Number(total) || 0,
    tabs: response?.tabs ?? response?.tabList ?? payload?.tabs ?? payload?.tabList ?? [],
    fields: response?.fields ?? response?.fieldConfig ?? payload?.fields ?? payload?.fieldConfig ?? [],
    tabField: response?.tabField ?? payload?.tabField ?? '',
    actionRules: payload?.actionRules ?? [],
    actions: payload?.actions ?? [],
    columnActions: payload?.columnActions ?? [],
  };
}
